import { render } from "./Agency.vue?vue&type=template&id=74192c8d&ts=true"
import script from "./Agency.vue?vue&type=script&lang=ts"
export * from "./Agency.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__